<template>
<div class="chapter">
<div class="inner_page">
<div class="image_container">
<a id="page_vi"></a><img alt="Image" src="images/fvi-01.jpg"/></div>
<div class="image_container">
<a id="page_vii"></a><img alt="Image" src="images/fvii-01.jpg"/></div>
<div class="image_container">
<a id="page_viii"></a><img alt="Image" src="images/fviii-01.jpg"/>
<p class="caption"><em class="italic">A Home Guard checks the identity card of a policeman c1940. Fears of Nazi ‘Fifth Columnist’ infiltrators in disguise meant that nobody’s identity was taken for granted and a challenge to produce your identity card by any civil or military official could not be refused.</em></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Fm01.vue?f6464afc